import { inject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { SalesForecastService } from 'pages/sales-forecast/service';
import { formatTableDate } from 'resources/utility';

@inject(DialogController, SalesForecastService)
export class Export {
    constructor(controller, salesForecastService) {
        this.controller = controller;
        this.salesForecastService = salesForecastService;
        this.exportFormat = 'Annual';
        this.isRequesting = false;

        this.columns = [
            { dataField: 'type' },
            { dataField: 'createdAt', customizeText: (cellInfo) => formatTableDate(cellInfo, true), sortOrder: 'desc'  },
            { caption: 'Actions', cellTemplate: (container, options) => {
              const button = document.createElement('button');
              button.className = 'btn btn-primary';
              button.innerHTML = 'Download';
              button.addEventListener('click', () => this.download(options.data, button));
              const div = document.createElement('div');
              div.style.textAlign = 'left';
              div.append(button);
              container.append(div);
            }, allowExporting: false }
        ];
    }

    download = async (data, button) => {
      button.disabled = true;
      button.innerHTML = '<i class="bx bx-loader-alt bx-spin"></i>';
      try {
        await this.salesForecastService.download(data.id);
      } finally {
        button.disabled = false;
        button.innerHTML = 'Download';
      }
    }

    async create() {
      this.isRequesting = true;
      try {
        await this.salesForecastService.create(this.exportFormat);
      } catch (error) {
        console.error(error);
      } finally {
        this.isRequesting = false;
        this.grid.refresh();
      }
    }
}